import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useAliasRenderer } from "@/hooks/useAliasRenderer";
import { Chip } from "@mui/material";
import { useGetOne } from "react-admin";
export var ContestItem = function (props) {
    var record = props.record;
    var aliasRendere = useAliasRenderer();
    var data = useGetOne("sequent_backend_contest", { id: record }).data;
    return _jsx(_Fragment, { children: data ? _jsx(Chip, { label: aliasRendere(data) }) : null });
};
